import { allModelsSelector } from 'common-src/utils/selectorUtils';

export const getPatientBillingExemptions = (state, patientId) =>
  allModelsSelector(
    state,
    'PatientBillingExemption',
    (billingExemption) => billingExemption.patientId === patientId,
  );
